import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import * as AppRouting from './feature.routing';
import { HomeComponent } from '@app/features/home/home.component';
import { SampleComponent } from '@app/features/sample/sample.component';
import { JourneyComponent } from '@app/features/journey.component';
import { ProfileComponent } from '@app/features/profile/profile.component';
import { ShareModule } from '@app/shared/shared.module';
import { SaveComponent } from '@app/features/save/save.component';

import { QuestionService } from '@app/core/question.service';
import { QuestionControlService } from '@app/core/question-control.service';
import { KycService } from '@app/core/kyc.service';

import { MyNeedsComponent } from './my-needs/my-needs.component';
import { CoverageComponent } from '@app/features/coverage/coverage.component';
import { NewPolicyComponent } from '@app/features/coverage/new-policy/new-policy.component';
import { PolicyDetailsComponent } from '@app/features/coverage/policy-details/policy-details.component';
import { MyNeedsModule } from './my-needs/my-needs.module';
import { NavTabService } from '@app/core/navTab.service';
import {
  ProfileRouteGuard,
  MyNeedsRouteGuard,
  CoverageRouteGuard,
  SaveRouteGuard,
  EmailRequiredGuard,
  ReferralCodeGuard
} from '@app/shared/common/route-guard';
import { ThankYouComponent } from './thank-you/thank-you.component';
import { MyDatePickerModule } from 'mydatepicker';

@NgModule({
  declarations: [
    HomeComponent,
    SampleComponent,
    JourneyComponent,
    ProfileComponent,
    CoverageComponent,
    NewPolicyComponent,
    PolicyDetailsComponent,
    MyNeedsComponent,
    SaveComponent,
    ThankYouComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ShareModule,
    MyNeedsModule,
    MyDatePickerModule,
    RouterModule.forChild(AppRouting.routes)
  ],
  providers: [
    QuestionService,
    QuestionControlService,
    NavTabService,
    KycService,
    ProfileRouteGuard,
    CoverageRouteGuard,
    MyNeedsRouteGuard,
    SaveRouteGuard,
    EmailRequiredGuard,
    ReferralCodeGuard
  ]
})
export class FeatureModule {}



// WEBPACK FOOTER //
// ./src/app/features/feature.module.ts